import React, { useState, useEffect, useRef } from 'react';
import SliderProductsContainer from 'containers/SliderProducts';
import CmsService from 'services/CMS';
import { useViewportMediaQuery } from 'hooks'
import PropTypes from 'prop-types';
import WrapperOptimizer from 'components/WrapperOptimizer';
import style from './style.scss'; //NOSONAR


const ShelfTab = ({data, dateServer}) => {

    const [tab, setTab] = useState(0);
    
    const [withArrows, setArrows] = useState(true);
    const [arrowLeft, setLeft] = useState(true);
    const [arrowRight, setRight] = useState(true);
    const [tabsArray, setTabsArray] = useState([]);
    const line = useRef('');
    const slider = useRef('');
    const tabsRef = useRef([]);
    const scroller = useRef();
    const isMobile = useViewportMediaQuery(1024);

    useEffect(() => {

        let shelfTab = data ? data.tabs : [];
        setTabsArray(shelfTab.map((item) => {

            if (!item.collection) return false;
            if (item.active !== true) return false;
            if(!CmsService.validDatesItem(item, dateServer)) return false;

            return item;
        }).filter(Boolean));

        if(typeof window !== 'undefined') {
            window.addEventListener("resize", displayArrows);
        }

        return function cleanup(){
            if(typeof window !== 'undefined') {
                window.removeEventListener("resize", displayArrows);
            }
        }

    }, []);

    useEffect(() => {
        moveLineTab()
        displayArrows()
    },[tabsArray, tab, isMobile])
    
    const displayArrows = () => {
        const totalTabs = scroller.current ? scroller.current.scrollWidth : 0;
        const widthScrollerTabs = scroller.current ? Math.round(scroller.current.getBoundingClientRect().width) : 0;
        const withArrow = Math.abs(totalTabs - widthScrollerTabs) > 20;

        if(!withArrow){
            setArrows(false);
        } else {
            if(tab === 0){
                setLeft(false)
                setRight(true)
            }else if(tab === tabsArray.length - 1){
                setRight(false)
                setLeft(true)
            }else{
                setLeft(true)
                setRight(true)
            }
            setArrows(true);
        }
    }

    const change = (value) => {
        setItem(value);
    }

    const notProducts = (value, i) => {
        if(!value && tabsArray && tabsArray.length){
            let _tabs = [...tabsArray];
            _tabs.splice(i, 1);
            setTabsArray(_tabs);
        }
    }

    const setItem = (pos) => {
        
        if(!tabsRef.current[pos]) return false;

        const element = scroller.current;
        const coordScroll = element.getBoundingClientRect();
        const coorNewX = tabsRef.current[pos].getBoundingClientRect();
        if((coorNewX.x + coorNewX.width) > coordScroll.width){
            const tam = coorNewX.left + coorNewX.width - coordScroll.x;
            element.scrollBy(tam - coordScroll.width, 0)
        }

        if(coorNewX.x < coordScroll.x){
            const tam = Math.round(coorNewX.x - coorNewX.width) + coordScroll.x;
            element.scrollBy(tam, 0)
        }

        setTab(pos);
    };

    const handlePrev = () => {
        setItem(tab - 1, 'prev')
    }
    const handleNext = () => {
        setItem(tab + 1, 'next')
    }


    const moveLineTab = () => {
        if(line.current && tabsRef.current && tabsRef.current[tab]){
            let totalWidth = 0;
            for(let i = 0; i < tab; i++){
                totalWidth += tabsRef.current[i].getBoundingClientRect().width;
            }
            const left = Math.round(totalWidth);
            line.current.style.width = Math.round(tabsRef.current[tab].offsetWidth) + 'px';
            line.current.style.left = left + 'px';
        }
    }

    return (
        <section className="tabs-slider-content">
            <div className="tabs-titles" >
                <div className={'slider-tabs-titles'} ref={slider}>
                    {withArrows && <button className={'tab-prev-button ' + (arrowLeft ? 'active' : '') } onClick={handlePrev} aria-label="slider prev button"/>}
                    <ul className="slides-tabs" ref={scroller}>
                        {tabsArray.map((dataTab, i) => {
                            return (
                                <li key={i} ref={el => (tabsRef.current[i] = el)} className={"tab-title-content" + (tab === i ? ' active' : '')} onClick={() => change(i)}>
                                    <div className={'shelf-title mobile-click' + (tab === i ? ' active' : '') } key={i} >{dataTab.title}</div>
                                </li>)
                        })}
                        <span ref={line} className="line-tab"></span>
                    </ul>
                    {withArrows && <button className={'tab-next-button ' + (arrowRight ? 'active' : '')  } onClick={handleNext} aria-label="slider next button"/>}
                </div>
            </div>
            {tabsArray.map((dataTab, i) => {
                return (
                    <div key={i} className={'tab-slider' + (tab === i ? ' active' : '')}>
                        <WrapperOptimizer typeComponent="home_sliders_products">
                            {(dataWrapper) => {
                                return <SliderProductsContainer options={{ collections: 'H:' + dataTab.collection, position: i }} listTitle={'Vitrina ' + data.shelfIsland} tab={tab} callbackNotProducts={(value) => notProducts(value, i)} campaignData={dataWrapper}/>
                            }}
                        </WrapperOptimizer>
                    </div>)
            })}
        </section>
    )
}


ShelfTab.propTypes = {
    data: PropTypes.object,
    dateServer: PropTypes.number
};

export default ShelfTab;
